const binding = { modules: {}, dataActions: {} };

    const registerActionId = (actionPath) => {
        if (binding.dataActions[actionPath] &&
            binding.dataActions[actionPath].default &&
            binding.dataActions[actionPath].default.prototype &&
            binding.dataActions[actionPath].default.prototype.id) {
            binding.dataActions[binding.dataActions[actionPath].default.prototype.id] = binding.dataActions[actionPath];
        } else {
            Object.keys(binding.dataActions[actionPath] || {}).forEach(exportName => {
                if (binding.dataActions[actionPath][exportName] &&
                    binding.dataActions[actionPath][exportName].prototype &&
                    binding.dataActions[actionPath][exportName].prototype.Action) {
                    binding.dataActions[binding.dataActions[actionPath][exportName].prototype.id] = binding.dataActions[actionPath][exportName];
                }
            })
        }
    };

    const registerSanitizedActionPath = (sanitizedActionPath, dataAction) => {
        if (process.env.NODE_ENV === 'development') {
            if (!dataAction.default) {
                throw new Error('Data action path does not have a default export');
            }
            if (!(dataAction.default.prototype.id && binding.dataActions[dataAction.default.prototype.id]) || !binding.dataActions[sanitizedActionPath]) {
                binding.dataActions[sanitizedActionPath] = dataAction;
            }
        } else {
            binding.dataActions[sanitizedActionPath] = dataAction;
            if (!binding.dataActions[sanitizedActionPath].default) {
                throw new Error('Data action path ' + sanitizedActionPath + ' does not have a default export');
            }
            binding.dataActions[sanitizedActionPath].default.prototype.RegistrationId = sanitizedActionPath;
            if (binding.dataActions[sanitizedActionPath].default.prototype.id) {
                binding.dataActions[binding.dataActions[sanitizedActionPath].default.prototype.id] = sanitizedActionPath;
            }
        }
    };
    

    (binding.modules['dobbiesclub'] = {
        c: () => require('partner/themes/dobbiesclub/dobbiesclub.tsx'),
        $type: 'themeModule',
        da: [{name:'attributeDefinitions',  path:'@msdyn365-commerce-modules/retail-actions/dist/lib/get-attribute-definitions', moduleName: 'checkout',runOn: 0},{name:'attributeDefinitions',  path:'@msdyn365-commerce-modules/retail-actions/dist/lib/get-attribute-definitions', moduleName: 'loyalty-sign-up',runOn: 0},{name:'checkout',  path:'@msdyn365-commerce/global-state/dist/lib/data-actions/checkout-state-data-action', moduleName: 'loyalty-sign-up',runOn: 1},{name:'customerInformation',  path:'@msdyn365-commerce-modules/retail-actions/dist/lib/get-customer', moduleName: 'checkout',runOn: 0},{name:'customerInformation',  path:'@msdyn365-commerce-modules/retail-actions/dist/lib/get-customer', moduleName: 'loyalty-sign-up',runOn: 0},{name:'getCustomerAddress',  path:'themes/dobbies/actions/get-customer-address.action', moduleName: 'loyalty-sign-up',runOn: 0},{name:'inputsValidations',  path:'themes/dobbiesclub/actions/input-field-validation-action', moduleName: 'loyalty-sign-up',runOn: 0},{name:'loyaltyCard',  path:'@msdyn365-commerce-modules/retail-actions/dist/lib/get-loyalty-card', moduleName: 'order-confirmation',runOn: 0}],
        definitionExtensions: ['checkout','dobbies-checkout-shipping-address','footer-category','loyalty-sign-up','order-confirmation'],
        iNM: false,
        ns: '__local__',
        n: 'dobbiesclub',
        p: '__local__',
        
        pdp: '',
        
        themeSettings: 'dobbiesclub.theme.settings.json',
        md: 'src/themes/dobbiesclub'
    });
        

        {
            const sanitizedActionPath = '@msdyn365-commerce-modules/retail-actions/dist/lib/get-attribute-definitions';
            let dataAction = require('@msdyn365-commerce-modules/retail-actions/dist/lib/get-attribute-definitions');
            registerSanitizedActionPath(sanitizedActionPath, dataAction);
        }
            

        {
            const sanitizedActionPath = '@msdyn365-commerce-modules/retail-actions/dist/lib/get-attribute-definitions';
            let dataAction = require('@msdyn365-commerce-modules/retail-actions/dist/lib/get-attribute-definitions');
            registerSanitizedActionPath(sanitizedActionPath, dataAction);
        }
            

        {
            const sanitizedActionPath = '@msdyn365-commerce-modules/retail-actions/dist/lib/get-customer';
            let dataAction = require('@msdyn365-commerce-modules/retail-actions/dist/lib/get-customer');
            registerSanitizedActionPath(sanitizedActionPath, dataAction);
        }
            

        {
            const sanitizedActionPath = '@msdyn365-commerce-modules/retail-actions/dist/lib/get-customer';
            let dataAction = require('@msdyn365-commerce-modules/retail-actions/dist/lib/get-customer');
            registerSanitizedActionPath(sanitizedActionPath, dataAction);
        }
            

        {
            const sanitizedActionPath = '@msdyn365-commerce-modules/retail-actions/dist/lib/get-loyalty-card';
            let dataAction = require('@msdyn365-commerce-modules/retail-actions/dist/lib/get-loyalty-card');
            registerSanitizedActionPath(sanitizedActionPath, dataAction);
        }
            

        {
            const sanitizedActionPath = '@msdyn365-commerce/global-state/dist/lib/data-actions/checkout-state-data-action';
            let dataAction = require('@msdyn365-commerce/global-state/dist/lib/data-actions/checkout-state-data-action');
            registerSanitizedActionPath(sanitizedActionPath, dataAction);
        }
            

        {
            const sanitizedActionPath = 'themes/dobbies/actions/get-customer-address.action';
            let dataAction = require('partner/themes/dobbies/actions/get-customer-address.action');
            registerSanitizedActionPath(sanitizedActionPath, dataAction);
        }
            

        {
            const sanitizedActionPath = 'themes/dobbiesclub/actions/input-field-validation-action';
            let dataAction = require('partner/themes/dobbiesclub/actions/input-field-validation-action');
            registerSanitizedActionPath(sanitizedActionPath, dataAction);
        }
            

        
    window.__bindings__ = window.__bindings__ || {};
    window.__bindings__.modules = {
        ...window.__bindings__.modules || {},
        ...binding.modules
    };
    
        window.__bindings__.dataActions = {
        ...window.__bindings__.dataActions || {},
        ...binding.dataActions
    };